import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/info.svg'
import _imports_2 from '../../globalModule/assets/github.png'
import _imports_3 from '../../globalModule/assets/xcode-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-311202c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dialog-inner"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "align-icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "32",
  width: "32",
  src: _imports_0,
  alt: "close icon"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "align-icon" }
const _hoisted_7 = {
  key: 0,
  class: "jonothan-container"
}
const _hoisted_8 = { class: "img-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Upload to Github"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "GitHub")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Local IDE", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextBubble = _resolveComponent("TextBubble")!

  return (_ctx.ncStore.buildCodes !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "icon-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ncStore.buildCodes = undefined))
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "icon-button",
              onClick: _cache[1] || (_cache[1] = () => _ctx.isInfoActive = !_ctx.isInfoActive)
            }, [
              _createElementVNode("img", {
                class: _normalizeClass({'activeInfo' : _ctx.isInfoActive}),
                height: "32",
                width: "32",
                src: _imports_1,
                alt: "info icon"
              }, null, 2)
            ])
          ])
        ]),
        (_ctx.isInfoActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_TextBubble, { text: "You may publish your project on GitHub or export locally to your machine" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('buildLocal'))),
              src: _imports_3,
              alt: "Download locally"
            }),
            _hoisted_10
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}